import { useTranslation } from 'next-i18next';
import React, { FC } from 'react';
import { Button } from 'shared/ui';
import styled from 'styled-components';
import { Modal } from 'widgets/common';

type IDisableOrderModalProps = {
  show: boolean;
  onHide: () => void;
};

export const DisableOrderModal: FC<IDisableOrderModalProps> = ({ show, onHide }) => {
  const { t } = useTranslation('utils');

  return (
    <Modal isVisible={show} onClose={onHide}>
      <StyledContainer>
        <StyledTitle>{t('modals.disableOrderModal.title')}</StyledTitle>
        <Text>{t('modals.disableOrderModal.description')}</Text>
        <StyleButton onClick={() => onHide()}>{t('modals.disableOrderModal.buttonContractYes')}</StyleButton>
      </StyledContainer>
    </Modal>
  );
};

const StyledContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
});

const StyledTitle = styled.span({
  fontSize: 20,
  fontWeight: 'bold',
  color: '#232832',
  marginBottom: '10px',
  lineHeight: '1.05',
  letterSpacing: 'normal',
});

const Text = styled.span({
  fontSize: 13,
  lineHeight: '20px',
  color: '#232832',
  marginBottom: '30px',
  marginTop: '20px',
  letterSpacing: 'normal',
});

const StyleButton = styled(Button)({
  marginBottom: -20,
  border: 'solid 0.5px #8b33ff',
  backgroundColor: '#fff',
  color: '#8b33ff',
  '&:hover': {
    color: '#fff',
    backgroundColor: '#8b33ff',
  },
});
